
/**
 * Antwortmöglichkeiten von SC-Aufgaben.
 * Bindet die Inputs ng-model an das scope von v3sExercise über 'require' und Einbindung des Controllers
 * 
 * @class directive_v3sScAnswer
 * @memberOf v3sWbtPlayerApp:exercise:choice
 */
angular.module('v3sWbtPlayerApp').directive('v3sScAnswer', [ function () {
    return {
        restrict: 'E',
        require: ['^v3sExercise', '^v3sDocument', '?^v3sScAnswerGroup'],
        controller: 'v3sAnswerController',
        transclude: true,
        template: '<label v3s-clickable><input type="radio" ng-model="answer.id" value="{{id}}" bs-radio></input></label>',
        scope: {
            'id': '@'
        },
        link: function (scope, element, attrs, controllers, transclude) {
            var exCtrl = controllers[0];
            var docCtrl = controllers[1];
            var scgrpCtrl = controllers[2];

            scope.getVar = docCtrl.getVar;

            if (!!scope.id) {
                docCtrl.addElement(element);
            }
            var answerElement = scope.answerElement;
            if (!!scgrpCtrl) {
                scgrpCtrl.bindAnswerId(scope);
                scgrpCtrl.addAnswer(answerElement);
            } else {
                exCtrl.bindAnswerId(scope);
                exCtrl.addAnswer(answerElement);
            }

            var isUserAnswer = answerElement.getUserAnswer();
            if (!!isUserAnswer) {
                scope.answer.id = answerElement.id;
            }
            transclude(scope, function (clone, scope) { scope.transcludeFunction(clone, scope); });
            if (!element.hasClass('graphicAnswer')) {
                element.addClass('defaultAnswer');
            }

            function preventEventBehavior(evt) {
                evt.stopPropagation();
            }
            element.bind('touchstart', preventEventBehavior);
            element.bind('touchend', preventEventBehavior);
        }
    };
}]);
